import React from "react";
import PropTypes from "prop-types";

// material
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Drawer,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

// components
import Markdown from "@/components/shared/markdown";

//style
import { useStyles } from "./style";

export default function InfoModal({ title, content, mobileContent, open, onClose }) {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleClose = () => {
        onClose();
    };

    if (isMobile) {
        return (
            <Drawer open={open} onClose={handleClose} size={{ height: "100%", width: "100%" }} anchor="right">
                {title && (
                    <Box className={`${classes.titleWrapper} ${classes.drawerTitle}`}>
                        <Typography className={classes.titleHeading}>{title}</Typography>
                        <IconButton color="default" variant="normal" size="small" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                )}
                <Markdown renderHTML={true}>{mobileContent}</Markdown>
            </Drawer>
        );
    }

    return (
        <Dialog fullWidth open={open} onClose={handleClose} maxWidth="xl" transitionDuration={250}>
            {title && (
                <DialogTitle disableTypography className={classes.titleWrapper}>
                    <Typography className={classes.titleHeading}>{title}</Typography>
                    <IconButton color="default" variant="normal" size="small" onClick={handleClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
            )}
            <DialogContent>
                <Markdown renderHTML={true}>{content}</Markdown>
            </DialogContent>
        </Dialog>
    );
}

InfoModal.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    mobileContent: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

InfoModal.defaultProps = {
    open: false,
};
